import React from 'react';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import {replace} from "react-router-redux";
import { NotificationManager } from 'react-notifications';

import UserRoles from "../../../../../common/src/enums/UserRoles";
import {
    ROUTE_SECTION,
    ROUTE_SETTINGS
} from '../../../constants/routeconstants';
import * as AdminActions from "../../../actions/admin";

import UserFieldElement from "../../reusable/UserFieldElement";
import UserFieldDataType from "../../../utils/enums/UserFieldDataTypeEnum";
import PropTypes from "prop-types";
import SettingsGeneral from "./subPages/SettingsGeneral";
import SettingsDeposits from "./subPages/SettingsDeposits";
import SettingsPrizes from "./subPages/SettingsPrizes";
import SettingsMarkings from "./subPages/SettingsMarkings";
import SettingsKilometers from "./subPages/SettingsKilometers";

class SectionPage extends React.Component {

    static propTypes = {
        section: PropTypes.object,
    };

    static getId() {
        return ROUTE_SECTION;
    }

    static getAllowedRoles() {
        return [UserRoles.MAIN_ADMIN, UserRoles.SECTION_ADMIN, UserRoles.CLUB_ADMIN]; // empty means allowed for all
    }

    constructor(props) {
        super(props);
        this.state = {
            allowNew: false
        }
    }

    componentDidMount() {
        this.loadSection(this.props);
        this.loadSections(this.props);
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.params.subpage !== this.props.params.subpage) {
            this.setAllowNew(false)
        }

        if (nextProps.params.sectionNo !== this.props.params.sectionNo) {
            this.setAllowNew(false)
            this.loadSection(nextProps);
        }
    }

    loadSection = newestProps => {
        newestProps.dispatch(AdminActions.getGeneral(() => {this.forceUpdate();}));
        //if (newestProps.params.sectionNo.toLowerCase() === 'ddb') {
        //    if (this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id) newestProps.dispatch(AdminActions.getGeneral(() => {this.forceUpdate();}));
        //}
        if (newestProps.params.sectionNo.toLowerCase() !== 'ddb') {
            if (this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id || this.props.auth.currentEntity === this.props.params.sectionNo) {
                if (newestProps.params.sectionNo.length === 2) newestProps.dispatch(AdminActions.getSection(newestProps.params.sectionNo, () => {this.forceUpdate();}));
                else if (newestProps.params.sectionNo.length === 3) newestProps.dispatch(AdminActions.getClub(newestProps.params.sectionNo, () => {this.forceUpdate();}));
            }
        }
    };

    loadSections = (newestProps) => {
        newestProps.dispatch(AdminActions.getSections(() => {this.forceUpdate();}));
    }

    subForm = null;
    fields = [];
    render() {
        if (!this.props.auth.isAuthenticated) return <div></div>;

        const sectionNo = this.props.params.sectionNo;
        const section = sectionNo === "ddb" ? (!this.props.admin.generalSection ? null : this.props.admin.generalSection) :
            sectionNo.length === 2 ? (!this.props.admin.sections ? null : this.props.admin.sections.get(sectionNo) || null) :
            sectionNo.length === 3 ? (!this.props.admin.clubs ? null : this.props.admin.clubs.get(sectionNo) || null) : null;
        if (!this.props.admin.generalSection || section === null || typeof(section.isFullLoaded) === 'undefined') return null;

        if (this.props.auth.isAuthenticated && this.props.auth.currentRole !== UserRoles.MAIN_ADMIN.id && this.props.auth.currentEntity !== this.props.params.sectionNo) return <div className="unauthorized">
            Du har ingen rettigheder til denne side
        </div>

        let subPage = null;
        switch (this.props.params.subpage) {
            case 'general':
                subPage = <SettingsGeneral section={section} editMode={this.props.params.mode === "edit"} sectionNo={sectionNo} isDDB={sectionNo === "ddb"} isSection={sectionNo.length === 2} isClub={sectionNo !== "ddb" && sectionNo.length === 3} ref={instance => {this.subForm = instance;}}/>
                break;
            case 'deposits':
                subPage = <SettingsDeposits section={section} editMode={this.props.params.mode === "edit"} sectionNo={sectionNo} isDDB={sectionNo === "ddb"} isSection={sectionNo.length === 2} isClub={sectionNo !== "ddb" && sectionNo.length === 3} ref={instance => {this.subForm = instance;}}/>
                break;
            case 'prizes':
                subPage = <SettingsPrizes section={section} editMode={this.props.params.mode === "edit"} sectionNo={sectionNo} setAllowNew={this.setAllowNew} isDDB={sectionNo === "ddb"} isSection={sectionNo.length === 2} isClub={sectionNo !== "ddb" && sectionNo.length === 3} ref={instance => {this.subForm = instance;}}/>
                break;
            case 'markings':
                subPage = <SettingsMarkings section={section} editMode={this.props.params.mode === "edit"} sectionNo={sectionNo} isDDB={sectionNo === "ddb"} isSection={sectionNo.length === 2} isClub={sectionNo !== "ddb" && sectionNo.length === 3} ref={instance => {this.subForm = instance;}}/>
                break;
            case 'kilometers':
                subPage = <SettingsKilometers section={section} editMode={this.props.params.mode === "edit"} sectionNo={sectionNo} setAllowNew={this.setAllowNew} isDDB={sectionNo === "ddb"} isSection={sectionNo.length === 2} isClub={sectionNo !== "ddb" && sectionNo.length === 3} ref={instance => {this.subForm = instance;}}/>
                break;
        }

        let sectionList = this.props.admin.sections.map(section => {return {key: section.Sektionsnr, value: section.Sektionsnr + ' - ' + (section.Navn === null ? '' : section.Navn)}}).toArray()
        sectionList.unshift({key: 'ddb', value: 'DDB'})

        return (
            <div>
                <div className="sub-page-title">
                    <h2>Indstillinger</h2>
                </div>
                <div className="sub-page-content">
                    <div className="tab-list">
                        {sectionNo === "ddb" || sectionNo.length === 2 ? <Link className={(this.props.params.subpage === 'general' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled'))} to={this.props.params.mode === 'view' ? ROUTE_SETTINGS.replace(':subpage', 'general').replace(':sectionNo', sectionNo).replace(':mode', 'view'): ''}>
                            <span className="tab-text">Generelt</span>
                        </Link> : null}
                        <Link className={(this.props.params.subpage === 'deposits' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled'))} to={this.props.params.mode === 'view' ? ROUTE_SETTINGS.replace(':subpage', 'deposits').replace(':sectionNo', sectionNo).replace(':mode', 'view'): ''}>
                            <span className="tab-text">Indskud</span>
                        </Link>
                        <Link className={(this.props.params.subpage === 'prizes' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled'))} to={this.props.params.mode === 'view' ? ROUTE_SETTINGS.replace(':subpage', 'prizes').replace(':sectionNo', sectionNo).replace(':mode', 'view'): ''}>
                            <span className="tab-text">Præmier</span>
                        </Link>
                        <Link className={(this.props.params.subpage === 'markings' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled'))} to={this.props.params.mode === 'view' ? ROUTE_SETTINGS.replace(':subpage', 'markings').replace(':sectionNo', sectionNo).replace(':mode', 'view'): ''}>
                            <span className="tab-text">Markeringer</span>
                        </Link>
                        {sectionNo === "ddb" || sectionNo.length === 2 ? <Link className={(this.props.params.subpage === 'kilometers' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled'))} to={this.props.params.mode === 'view' ? ROUTE_SETTINGS.replace(':subpage', 'kilometers').replace(':sectionNo', sectionNo).replace(':mode', 'view'): ''}>
                            <span className="tab-text">KM-tillæg</span>
                        </Link> : null}
                    </div>
                    <div id="tab-page" className="tab-page">
                        {subPage}
                    </div>
                </div>
                <div className="sub-page-actions">
                    {this.props.params.mode === 'view' ? [
                        this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? [
                            <span key={1}>
                                <label htmlFor="week">Sektion/DDB</label>
                            </span>,
                            <span key={2}>
                                <UserFieldElement dataType={UserFieldDataType.enum} placeholder={'false'} className="field250" containerClassName="display-inline-block"
                                                  name="sectionPicker" id="sectionPicker" value={sectionNo} options={sectionList}
                                                  autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                  onChange={e => {
                                                      this.props.dispatch(replace(ROUTE_SETTINGS.replace(':subpage', this.props.params.subpage).replace(':sectionNo', e.target.value).replace(':mode', 'view')));
                                                  }}
                                />
                            </span>
                        ] : null,
                        <span className="left-buttons" key="left" key={3}>
                            <button className="btn-primary" title="Rediger sektion" disabled={(!this.props.auth.isMainAdmin && (!this.props.auth.isClubAdmin || this.props.auth.clubNumber !== sectionNo)) || this.props.params.subpage === 'kilometers' } onClick = {() => {
                                this.props.dispatch(replace(ROUTE_SETTINGS.replace(':subpage', this.props.params.subpage).replace(':sectionNo', sectionNo).replace(':mode', 'edit')));
                            }}>Rediger</button>
                            {this.props.params.subpage === 'prizes' || this.props.params.subpage === 'kilometers' ?
                                <button className="btn-primary" title={this.props.params.subpage === 'prizes' ? 'Opret præmie' : 'Opret tillæg'} disabled={!this.state.allowNew} onClick = {() => {
                                    this.subForm.getWrappedInstance().createNew();
                                }}>Ny</button>
                            : null}
                        </span>,
                    ] : [
                        <span className="left-buttons" key="left" key={4}>
                            <button className="btn-primary" title="Gem ændringer" onClick = {() => {
                                this.subForm.getWrappedInstance().save(sectionNo => {
                                    const message = this.props.params.subpage === 'general' ? (`Bankoplysningerne for ${sectionNo === "ddb"? 'DDB' : 'sektion ' + sectionNo} er opdateret.`)
                                                   :this.props.params.subpage === 'deposits' ? (`Indskud for ${sectionNo === "ddb"? 'DDB' : 'sektion ' + sectionNo} er opdateret.`)
                                                   :this.props.params.subpage === 'prizes' ? (`Præmier for ${sectionNo === "ddb"? 'DDB' : 'sektion ' + sectionNo} er opdateret.`)
                                                   :/*this.props.params.subpage === 'markings' ?*/ (`Markeringer for ${sectionNo === "ddb"? 'DDB' : 'sektion ' + sectionNo} er opdateret.`)
                                    NotificationManager.success(message, "Opdatering", 4000);
                                    this.props.dispatch(replace(ROUTE_SETTINGS.replace(':subpage', this.props.params.subpage).replace(':sectionNo', sectionNo).replace(':mode', 'view')));
                                })
                            }}>Gem</button>
                        </span>,
                        <span className="right-buttons" key="right" key={5}>
                            <button className="btn-secondary" title="Annuller ændringer" onClick = {() => {
                                this.subForm.getWrappedInstance().forceUpdate(()=>{
                                    this.props.dispatch(replace(ROUTE_SETTINGS.replace(':subpage', this.props.params.subpage).replace(':sectionNo', sectionNo).replace(':mode', 'view')));
                                })
                            }}>Annuller</button>
                        </span>,
                    ]}
                </div>
            </div>
        );
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    setAllowNew = mode => this.setState({allowNew: mode});
}

const mapStateToProps = (state) => ({
    auth: {
        isAuthenticated: state.auth.isAuthenticated,
        isClubAdmin: state.auth.isClubAdmin,
        isMainAdmin: state.auth.isMainAdmin,
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
    admin: {
        sections: state.admin.sections,
        clubs: state.admin.clubs,
        generalSection:state.admin.generalSection
    }
});

export default connect(mapStateToProps)(SectionPage);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/settings/SettingsPage.js